import React from "react";
import { profileImgPlaceholder } from "../../../../assets/images";
import { Domain, request } from "../../../../config/API";
import { COLORS } from "../../../../config/theme";
import MainIconBar from "../MainIconBar";
import InfoBox from "../InfoBox";
import { Col, Row } from "antd";
import SocialIconBar from "../SocialIconBar";
const Theme8 = ({ vCard, isPreview, downloadVcfFile, setShowExchangeCard }) => {
  const { primaryColor } = COLORS;
  const {
    fNamePrefix,
    fName,
    lName,
    lNameSuffix,
    email,
    company,
    jobTitle,
    mobile,
    address,
    bgImage,
    profileImage,
    pColor,
    sColor,
    socialLinks,
    leadEnable,
    owner,
    webLinks,
  } = vCard;
  return (
    <Col style={{ width: "100%", backgroundColor: sColor }}>
      <Col
        style={{
          position: "relative",
          background: `linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0,0, 0.8)),
      ${bgImage ? `url(${Domain}/data/${bgImage})` : pColor}`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          overflow: "hidden",
          backgroundPosition: "center",
          height: "460px",
        }}
      >
        <Row
          style={{
            display: "flex",
            height: "250px",
          }}
        >
          <div
            style={{
              position: "absolute",
              bottom: 0,
              display: "flex",
              backgroundColor: sColor,
              height: 250,
              width: "50%",
              borderTopLeftRadius: 20,
              left: 0,
            }}
          />
          <div
            style={{
              position: "absolute",
              bottom: 0,
              display: "flex",
              backgroundColor: pColor,
              height: 250,
              width: "50%",
              borderTopRightRadius: 20,
              right: 0,
            }}
          />
        </Row>
        <Row span={24}>
          <Col
            span={8}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              draggable={false}
              style={{
                height: "7rem",
                width: "7rem",
                borderRadius: "1rem",
                zIndex: 99,
                marginLeft: 40,
              }}
              src={
                profileImage
                  ? `${Domain}/data/${profileImage}`
                  : profileImgPlaceholder
              }
              alt=""
            />
          </Col>
          <Col
            span={8}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <MainIconBar
              mobile={mobile}
              email={email}
              address={address}
              sColor={sColor}
              horizontal={false}
            />
          </Col>
          <Col
            span={8}
            style={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            <InfoBox
              fName={fName}
              jobTitle={jobTitle}
              company={company}
              black={false}
            />
          </Col>
        </Row>
      </Col>
      <SocialIconBar
        socialLinks={socialLinks}
        leadEnable={leadEnable}
        sColor={sColor}
        downloadVcfFile={downloadVcfFile}
        setShowExchangeCard={setShowExchangeCard}
        owner={owner}
        isBlack={false}
        webLinks={webLinks}
        isPreview={isPreview}
      />
    </Col>
  );
};

export default Theme8;
